import { CellType } from "./enums";
import { IUniversalDatasetTableRow } from "./interfaces";

const getUniversalTableDatasetValues = (rows: IUniversalDatasetTableRow[]) => {
  const datasetValues = new Set<string>();

  rows.forEach(row => {
    row.columns.forEach(column => {
      if (column.cell.type === CellType.DATASET && column.cell.value) {
        datasetValues.add(column.cell.value as string);
      }
    });
  });

  return [...datasetValues];
};

const findUniversalTableRowIdentifiers = (row: IUniversalDatasetTableRow) => {
  return row.columns
    .filter(column => column.cell.type === CellType.DATASET)
    .map(column => column.cell.value as string);
};

export { getUniversalTableDatasetValues, findUniversalTableRowIdentifiers };
